<template>
  <v-dialog v-model="dialogModel" persistent scrollable>
    <v-card>
      <v-flex class="d-flex align-center">
        <v-flex class="pl-3">
          <h3>Customer Orders</h3>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex class="text-xs-right">
          <v-btn flat @click="dialogModel = false">
            <v-icon left small>close</v-icon> Close
          </v-btn>
        </v-flex>
      </v-flex>

      <v-divider></v-divider>

      <v-flex>
        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <v-flex xs6 sm4 md3 lg2>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="orderQueryParams.fromOrderDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                  hide-details
                ></v-text-field>
                <v-date-picker
                  v-model="orderQueryParams.fromOrderDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6 sm4 md3 lg2>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="orderQueryParams.toOrderDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                  hide-details
                ></v-text-field>
                <v-date-picker
                  v-model="orderQueryParams.toOrderDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6 sm4 md3 lg2>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="orderQueryParams.issueNo"
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm4 md3 lg2>
              <v-btn outline color="primary" @click="orderOnSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>

      <v-divider></v-divider>

      <v-card-text height="500">
        <!-- Order List Section -->
        <v-flex xs12 class="mt-1">
          <v-card>
            <v-data-table
              :headers="orderHeaders"
              :items="orderList"
              class="elevation-1"
              :loading="showOrderListLoading"
              :total-items="orderTotalRows"
              :rows-per-page-items="orderRowsPerPageItems"
              :pagination.sync="orderPagination"
              :must-sort="true"
            >
              <template slot="items" slot-scope="props">
                <td>
                  {{ props.item.orderDateInMilliSeconds | formatMsDateTime }}
                </td>
                <td @click="apply(props.item)">
                  <a>{{ props.item.issueNo }}</a>
                </td>
                <td>{{ props.item.orderNo }}</td>
                <td>
                  {{
                    props.item.estimateDeliveryDateInMilliSeconds
                      | formatMsDateTime
                  }}
                </td>
                <td>
                  {{
                    props.item.csRequestDateInMilliSeconds | formatMsDateTime
                  }}
                </td>
                <td>{{ props.item.customerDTO.name }}</td>
                <td>{{ props.item.phoneNo }}</td>
                <td>{{ props.item.cityDTO.name }}</td>
                <td>{{ props.item.townshipDTO.name }}</td>
                <td>{{ props.item.userDTO.username }}</td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { orderService } from "../../services/order-service";
export default {
  props: ["dialog", "customerName", "shopId" ],
  data: () => ({
    orderQueryParams: {
      fromOrderDate: "",
      toOrderDate: "",
      issueNo: "",
      exactCustomerName: "",
      status: "PENDING",
      //wholesaleFlag: "False",
      shopId: "",
    },
    orderRowsPerPageItems: [25, 50, 100],
    orderHeaders: [
      { text: "Order Date", value: "orderDate" },
      { text: "Issue No", align: "left", value: "issueNo" },
      { text: "Order No", align: "left", value: "orderNo" },
      { text: "Est. Delivery Date", value: "estDate" },
      { text: "Customer Request Date", value: "csRequestDate" },
      { text: "Customer Name", value: "customerName" },
      { text: "Phone No", value: "phoneNo", sortable: false },
      { text: "City", value: "city" },
      { text: "Township", value: "township" },
      { text: "Order Person", value: "orderPerson" },
    ],
    showOrderListLoading: false,
    orderTotalRows: 0,
    orderPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    orderList: [],
  }),
  computed: {
    dialogModel: {
      get() {
        return this.dialog;
      },
      set() {
        this.$emit("update:dialog");
      },
    },
  },
  watch: {
    dialogModel(v) {
      if (v) {
        this.orderQueryParams.exactCustomerName = this.customerName;
        this.orderQueryParams.shopId = this.shopId;
        this.orderOnSearch();
      } else {
        this.orderQueryParams.fromOrderDate = "";
        this.orderQueryParams.toOrderDate = "";
        this.orderQueryParams.orderNo = "";
      }
    },
    orderPagination: {
      handler() {
        this.orderOnSearch();
      },
      deep: true,
    },
  },
  methods: {
    orderOnSearch() {
      this.orderQueryParams.page = this.orderPagination.page;
      this.orderQueryParams.size = this.orderPagination.rowsPerPage;
      this.getOrderList();
    },
    async getOrderList() {
      this.showOrderListLoading = true;
      let order = this.orderPagination.descending ? "desc" : "asc";

      try {
        const res = await orderService.getOrderList(
          this.orderQueryParams,
          this.orderPagination.page,
          this.orderPagination.rowsPerPage,
          this.orderPagination.sortBy + "," + order
        );
        if (res.data) {
          this.orderList = res.data.orderHeaderList;
          this.orderTotalRows = res.data.totalElements;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.showOrderListLoading = false;
      }
    },
    apply(order) {
      this.$emit("apply", order);
    },
  },
};
</script>

<style></style>
